import addNotification from "react-push-notification"
import logo from '../../Assets/logo512.png'

const SendPushNotification = (message: any) => {
    addNotification({ ...message, icon: logo, native: true });
}

export default SendPushNotification